import label from '@/api/product/label'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  locations: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
}

export const actions = {
  store(context, data) {
    return label.store(data)
  },
  printBarcode(context, data) {
    return label.printBarcode(data)
  },
  getProductSerial(context, data){
    return label.getProductSerial(data)
  },
  getProductBarcode(context, query){
    return label.getProductBarcode(query)
  },
  getProductProfile(context, data){
    return label.getProductProfile(data)
  },
  getStockIn(context, attrubutes = {}){
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return label.getStockIn({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getCategory(context){
    return label.getCategory()
  }
}